module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmpara1",
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0004#page_1"
    }
  }, [_vm._v("1.    Caesar’s Decree, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("the Mediterranean Sea")]), _vm._v(", 6 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0005#page_9"
    }
  }, [_vm._v("2.    The Star, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Bethlehem of Judea")]), _vm._v(", 6-5 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("C")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0006#page_16"
    }
  }, [_vm._v("3.    The Boy, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 6-7")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.    Cousins, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Nazareth of Galilee")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 11")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.    Into the Desert, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("the Judean Desert")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 17")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.    The Essence, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("the Judean Desert")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 17")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.    A Mother’s Divine Ache "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("on the outskirts of Nazareth")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 25")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.    Voice in the Wilderness, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("the River Jordan")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 27")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.    The Call, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Bethsaida of Galilee")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 27")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.   Outcast and Brother, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Capernaum of Galilee")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 27-28")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.   The Gathering, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Capernaum")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 27-28")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.   The Message, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("near Capernaum")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 27-28")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0016#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.   Tax Collectors and Sinners, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Capernaum")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 28")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0017#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.   Who is this Man, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("on the road to Caesarea-Philippi")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 29-30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0018#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.   New Assignment, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("the coast of Caesarea")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0019#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.   Witness to Love, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0020#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.   Witness to Sacrifice, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0021#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.   Witness to Salvation, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0022#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.   Witness to Life, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0023#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.   Eyewitness to Resurrection, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0024#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.   Winds of Power, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 30")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0025#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.   Deliverance of a Pharisee, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("outside Damascus")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 33")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0026#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.   Bonds of Leadership, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 33")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0027#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.   A Brother’s Prayer, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Jerusalem")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 45")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0028#page_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25.   A New Love to Change the World, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Ephesus")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 55")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0029#page_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26.   The Joy of Christ, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Rome")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 61")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0030#page_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27.   The Biography of God’s Son, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Corinth")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 63")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0031#page_203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.   Preservation of the Life, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Rome")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 68")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0032#page_212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29.   Tax Collector and Second Witness, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Capernaum")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 74")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0033#page_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30.   Physician and Third Witness, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("the Mediterranean")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 77")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0034#page_231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31.   A Beloved Disciple Defines God’s Nature, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Ephesus")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(".95")])]), _vm._v(" "), _c('p', {
    staticClass: "fmpara2"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0035#page_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.   God Becomes Man!, "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Ephesus")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "small"
  }, [_vm._v("D")]), _vm._v(". 96")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54396cd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0003.vue
// module id = 69
// module chunks = 0